/**
 * The events that drive WAIT states.
 *
 * A WAIT state advances only when the posted event matches its own
 * `nextState.event` (WorkflowInstanceRunnerExecuteWait), so this is the set an
 * admin should be offered on every state when setting an instance's state by
 * hand - a state that does not name one of these in its own definition is
 * simply not moved by it.
 *
 * Grounded in the events actually named by the workflow definitions in the
 * database, plus the events the platform posts itself:
 *
 * - `Submit`   - 408 WAIT states across 115 workflows; posted by form submit,
 *                profile creation, profile merge and the disclosure check.
 * - `Continue` -   8 WAIT states across   8 workflows.
 * - `Updated`  -   2 WAIT states across   2 workflows.
 * - `Payment`  - posted by processAfterPaymentWorkflowActionsBLL. No WAIT state
 *                currently names it.
 *
 * `Revoked`, `Removed` and `Archived` are named by no definition and posted by
 * no caller; they are kept only so existing seeds keep resolving.
 */
export enum WorkflowWaitStateEvents {
  Submit = "Submit",
  Continue = "Continue",
  Updated = "Updated",
  Payment = "Payment",
  Revoked = "Revoked",
  Removed = "Removed",
  Archived = "Archived",
}
